<template>
  <span
      :class="badgeClass"
      class="px-3 py-1 rounded text-xs font-semibold inline-block"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: "StatusBadge",
  props: {
    status: {
      type: String,
      default: "",
    },
  },
  computed: {
    label() {
      switch (this.status) {
        case "Draft":
          return "Draft";
        case "NotStarted":
          return "Not Started";
        case "InProgress":
          return "In Progress";
        case "Completed":
          return "Completed";
        case "CompletedWithFurtherWork":
          return "Further Work";
        case "ReadyForInvoice":
          return "Ready for Invoice";
        case "Invoiced":
          return "Invoiced";
        case "Closed":
          return "Closed";
        case "Cancelled":
          return "Cancelled";
        case "Assigned":
          return "Assigned";
        case "OnHold":
          return "On Hold";
        case "Failed":
          return "Failed";
        default:
          return this.status || "Unknown";
      }
    },
    badgeClass() {
      switch (this.status) {
        case "Draft":
          return "bg-gray-400 text-white";
        case "NotStarted":
          return "bg-blue-400 text-white";
        case "Assigned":
          return "bg-blue-400 text-white";
        case "InProgress":
          return "bg-blue-500 text-white";
        case "Completed":
          return "bg-green-500 text-white";
        case "CompletedWithFurtherWork":
          return "bg-red-500 text-white";
        case "Cancelled":
          return "bg-gray-400 text-white";
        case "ReadyForInvoice":
          return "bg-purple-700 text-white";
        case "Invoiced":
          return "bg-gray-500 text-white";
        case "Closed":
          return "bg-black text-white";
        case "OnHold":
          return "bg-orange-500 text-white";
        case "Failed":
          return "bg-red-700 text-white";
        default:
          return "bg-gray-200 text-gray-700";
      }
    },
  },
};
</script>
